module.exports = __webpack_public_path__ + "img/latest-article-cover.95f6491f.png";